import {
  Component,
  inject,
  OnInit,
  signal,
  TemplateRef,
  WritableSignal,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateRateModalComponent } from '../../components/create-rate-modal/create-rate-modal.component';
import { BulkCreateRateModalComponent } from '../../components/bulk-create-rate-modal/bulk-create-rate-modal.component';
import { ZoneService } from 'src/app/services/modules/instant-rate-manager/zone.service';
import { AlertUtil } from 'src/app/shared/utils/alert-dialog.util';

@Component({
  selector: 'app-instant-rates-manager',
  templateUrl: './instant-rates-manager.component.html',
  styleUrl: './instant-rates-manager.component.scss',
})
export class InstantRatesManagerComponent implements OnInit {
  router = inject(Router);
  modalService = inject(NgbModal);
  private zoneService = inject(ZoneService);

  hasNoZones = false;

  ngOnInit() {
    this.checkZones();
  }

  async checkZones() {
    try {
      const response = await this.zoneService.getProviderZones({
        page_size: 1,
        is_active: true,
      });
      this.hasNoZones = response.count === 0;
    } catch (error) {
      console.error('Error checking zones:', error);
    }
  }

  goTo = (url: string) => {
    this.router.navigate([url]);
  };

  openBulkUploadRateModal = async () => {
    if (this.hasNoZones) {
      await AlertUtil.info(
        'You must have at least one zone set up before you can import rates.'
      );
      this.goTo('/instant-rate-manager/provider-locations');
      return;
    }

    const modalRef = this.modalService.open(BulkCreateRateModalComponent, {
      size: 'lg',
      centered: true,
    });
  };
}
